/* eslint-disable no-restricted-globals */
import React, { useState, useEffect } from 'react';
import axiosInstance from '../../utils/axiosInstance';

const ManageComments = () => {
  const [commentsData, setCommentsData] = useState([]);

  // Fetch all blogs and comments
  const fetchComments = async () => {
    try {
      const { data } = await axiosInstance.get('/blogs/comment');
      console.log(data,"Comments")
      setCommentsData(data); // This assumes you're getting all blogs with their comments
    } catch (error) {
      console.error('Error fetching comments', error);
    }
  };

  useEffect(() => {
    fetchComments();
  }, []);

  // Delete a comment
  const handleDeleteComment = async (blogId, commentId) => {
    if(confirm("Are you sure you want to delete?")){
        try {
            await axiosInstance.delete(`/blogs/${blogId}/comments/${commentId}`);
            fetchComments(); // Refetch comments after deletion
          } catch (error) {
            console.error('Error deleting comment:', error);
          }
    }
   
  };

  return (
    <div className="container mx-auto p-6 bg-gradient-to-r from-blue-500 to-green-500 rounded-lg shadow-lg">
      <h1 className="text-3xl font-bold text-white mb-6">Manage Comments</h1>
      
      {commentsData.length > 0 ? (
        commentsData.map(comment => (
               <div key={comment.id} className=' bg-gray-100 p-3 rounded-lg mb-2 shadow-sm'> 
                <div className="flex flex-row items-center">
                   <p className="text-gray-600"><span className='text-green-500'>{comment.comment}.</span> <span style={{fontStyle:'italic'}}>By</span> <b>{comment.username}</b></p>
                  {/* <button
                    onClick={() => handleDeleteComment(comment.blog_id, comment.id)}
                    className="mt-2 bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-3 rounded mx-10"
                  >
                    Delete
                  </button> */}
                </div>
                <div>
                  <p><b>Article : </b>{comment.blog_title}</p>
                </div>

                </div>
              ))
            ) : (
              <p>No comments for this blog.</p>
            )}
          
      
    </div>
  );
};

export default ManageComments;
